export type InfoEventSelection = {
  targetHolidayId: string;
  targetInactivityId: string;
};

export function isInactivityEventId(eventId: string): boolean {
  return eventId.startsWith("inactivity-");
}

export function isHolidayEventId(eventId: string): boolean {
  return eventId.startsWith("holiday-");
}

export function resolveInfoEventSelection(eventId: string): InfoEventSelection {
  if (isInactivityEventId(eventId)) {
    return {
      targetHolidayId: "",
      targetInactivityId: eventId
    };
  }

  return {
    targetHolidayId: eventId,
    targetInactivityId: ""
  };
}
